import m from "../../geodata/es2015/spainProvincesLow";
window.am4geodata_spainProvincesLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/spainProvincesLow.js
// module id = null
// module chunks = 